import React from "react";
import "../styles/RefundAndReturns.css";

const RefundAndReturns = () => {
  return (
    <div className="refund-container">
      <h1>Refund & Returns Policy – Squarefeet Marble</h1>

      <section>
        <h2>Refund Policy</h2>
        <p>
          Our refund policy is valid for a period of 30 days from the date of
          purchase. If 30 days have passed since your purchase, we regret to
          inform you that we will not be able to offer a refund.
        </p>

        <p>
          To qualify for a refund, the product must be in the same condition as
          it was received and should not show signs of damage or misuse.
        </p>
      </section>

      <section>
        <h2>Proof of Purchase</h2>
        <p>
          To process your refund request, we require a valid receipt or proof
          of purchase. In certain cases, verification may be completed through
          a video call for confirmation.
        </p>

        <p>
          Please note that products should not be sent back directly to the
          manufacturer.
        </p>
      </section>

      <section>
        <h2>Partial Refunds</h2>
        <p>
          In specific situations, only a partial refund may be granted. This
          may apply if a marble slab is damaged or if an error has occurred from
          our side.
        </p>

        <p>
          In such cases, the applicable loss amount will be refunded within 7
          to 10 working days, subject to verification.
        </p>

        <p>
          Items that are returned in a condition different from their original
          state, or with missing parts not caused by our error, may not qualify
          for a full refund.
        </p>
      </section>

      <section>
        <h2>Refund Process</h2>
        <p>
          Once your refund request is submitted, we will notify you via email
          regarding the receipt of your request. You will then be informed
          whether your refund has been approved or rejected.
        </p>

        <p>
          If approved, your refund will be initiated and the amount will be
          credited back to your original payment method within a few working
          days, depending on your bank or payment provider.
        </p>
      </section>

      <section>
        <h2>Late or Missing Refunds</h2>
        <p>
          If you have not received your refund yet, please check your bank
          account again. After that, contact your credit card company, as it
          may take some time before the refund is officially posted.
        </p>

        <p>
          If the issue persists, we recommend reaching out to your bank.
          Processing delays are common and may vary.
        </p>

        <p>
          If you have completed all these steps and still have not received
          your refund, please contact us at{" "}
          <a href="mailto:squarefeetmarble@gmail.com">
            squarefeetmarble@gmail.com
          </a>
        </p>
      </section>

      <section>
        <h2>Sale Items</h2>
        <p>
          Items purchased on sale are not eligible for refunds. Certain
          discounted products may be excluded from our refund policy.
        </p>
      </section>

      <section>
        <h2>Shipping & Delivery</h2>
        <p>
          Delivery timelines may vary depending on your location. If you are
          returning an item, we strongly recommend using a trackable shipping
          service or opting for shipping insurance.
        </p>

        <p>
          We cannot guarantee receipt of returned items that are not shipped
          using a secure and traceable method.
        </p>
      </section>
    </div>
  );
};

export default RefundAndReturns;
